import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Input from '@active/react-ui/Input'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Form, { FormConsumer } from '@active/react-ui/Form'
import { Locale, withI18n } from '@active/react-utils/i18n'
import noop from 'lodash/noop'

import BillingAddress from '../../common/BillingAddress'
import CardNumberInfo from '../../common/CardNumberInfo'
import { yearData } from './data/expireDate'
import { paymentMethodPropType } from '../../common/paymentMethodTypes'
import ExpiredDateInput from './ExpiredDateInput'
import './SavedCreditCardForm.scss'

class SavedCreditCardForm extends PureComponent {
  static propTypes = {
    getSavedCreditCardCallBack: func.isRequired,
    paymentMethod: paymentMethodPropType.isRequired,
    submitTrigger: func,
    i18n: func.isRequired,
  }

  static defaultProps = {
    submitTrigger: noop,
  }

  submitFormTrigger = noop

  submitBillingAddress = noop

  constructor(props) {
    super(props)
    const {
      paymentMethod: {
        cardHolderName, expiredYear, expiredMonth, billingFirstName, billingLastName, address,
      },
    } = this.props
    this.state = {
      cardHolderName,
      expiredYear: yearData.find(({ value }) => value === expiredYear) ? expiredYear : null,
      expiredMonth,
      billingAddressInfo: {
        billingFirstName,
        billingLastName,
        address,
      },
    }
  }

  componentDidMount() {
    const { submitTrigger } = this.props
    submitTrigger(this.submitBillingAddress)
  }

  getBillingAddressCallBack = values => {
    if (values.errorCode && values.errorCode === 'BILLINGADDRESS_INVALID_PARAMS') {
      return
    }
    this.setState({
      billingAddressInfo: values,
    }, () => {
      this.submitFormTrigger()
    })
  }

  handleSubmit = values => {
    const { billingAddressInfo } = this.state
    const { paymentMethod, getSavedCreditCardCallBack } = this.props
    const updatePaymentMethod = {
      ...paymentMethod, ...billingAddressInfo, ...values, ...values.expiredDate,
    }
    if (billingAddressInfo.errorCode !== 'BILLINGADDRESS_INVALID_PARAMS') {
      getSavedCreditCardCallBack(updatePaymentMethod)
    }
  }

  handleCardHolderNameChange = ({ value: cardHolderName }) => {
    this.setState({ cardHolderName })
  }

  render() {
    const { paymentMethod, i18n } = this.props
    const {
      billingAddressInfo, cardHolderName, expiredMonth, expiredYear,
    } = this.state
    const initialValues = { cardHolderName, expiredDate: { expiredMonth, expiredYear } }

    return (
      <div className="checkout__save-cc checkout-cc">
        <h2 className="checkout__save-cc__title">
          <Locale id="passport.lib.components.creditCard.newCreditCardForm.title" />
        </h2>
        <Form
          horizontal
          trimInput
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
        >
          <FormGroup className="checkout__save-cc__cardNumber">
            <FormLabel><Locale id="passport.lib.components.common.card.number" /></FormLabel>
            <FormField
              name="cardNumber"
              as={CardNumberInfo}
              paymentMethod={paymentMethod}
            />
          </FormGroup>
          <FormGroup required className="checkout__save-cc__holderName">
            <FormLabel><Locale id="passport.lib.components.common.holder.name" /></FormLabel>
            <FormField
              className="checkout__save-cc__holderName-input"
              name="cardHolderName"
              as={Input}
              autoComplete="cc-number"
              onChange={this.handleCardHolderNameChange}
              requiredError={i18n('passport.lib.components.newCreditCard.validate.holderName')}
              validate={value => (value.length > 50 ? i18n('react-aaui.validation.max', 50) : undefined)}
            />
          </FormGroup>
          <FormGroup name="expiredDate" required className="checkout__save-cc__exp">
            <FormLabel id="ExpiredDateDropdownLabel" htmlFor="expiredDate"><Locale id="passport.lib.components.common.expiration.date" /></FormLabel>
            <FormField as={ExpiredDateInput} aria-labelledby="ExpiredDateDropdownLabel" />
          </FormGroup>
          <FormConsumer>
            {({ form: { submitForm } }) => {
              this.submitFormTrigger = submitForm
              return null
            }}
          </FormConsumer>
        </Form>
        <BillingAddress
          getBillingAddressCallBack={this.getBillingAddressCallBack}
          defaultValues={billingAddressInfo}
          submitTrigger={submitBillingAddress => {
            this.submitBillingAddress = submitBillingAddress
          }}
        />
      </div>
    )
  }
}

export default withI18n(SavedCreditCardForm)
